<template>
    <div :class="customClass">
    <!-- Top Navigation -->
        <nav class="navbar navbar-bg-gradient" >
            <div class="navbar-left">
                <template>
                <!-- Search -->
                <form action="/search-results/" v-on:submit.prevent="submitForm" class="app-form">  
                    <div class="input-group search">
                        <input id="menu-search" type="text"  placeholder="Search......">
                        <span class="input-addon" @click="resetSearch"></span>
                    </div>
                    <button type="submit" class="visually-hidden">Search</button>
                </form>
                </template>

                <h1 class="navbar-title" v-html="fullTitle"></h1>
            </div>

            <img src="img/logos/bayer-white.png" alt="Bayer" class="logo" />
        </nav>
    </div>
</template>

<script> 
    export default {
        name: 'NavBar',
        props: {
            title: {
                type: String
            },
            customClass: {
                type: String,
                default: ''
            }
        },
        computed: {
            currentRoute: function(){
                return this.$route.name == 'Search';
            },
            timelineIsHomepage: function(){
                //If localstorage item is not null, timeline is the homepage 
                return window.localStorage.getItem('appHomepageStatus') !== null;
            },
            currentRouteIsTimeline: function() {
                return this.$route.path == 'Timeline'; 
            },
            // If a matching productName is found, append its field_black_triangle_for_product value to the title
            fullTitle() {
                let title = this.title;

                const productNames = this.$store.getters.getProductNames;
                const product = productNames.filter(product => {
                    return product.title[0].value.trim() === this.title;
                });

                if (product[0] && product[0].field_black_triangle_for_product[0]) {
                    title += product[0].field_black_triangle_for_product[0].value;
                }

                return title;
            },
        },
        methods: {
            clearDisclaimerShown() {
                this.$store.dispatch('clearDisclaimerStatus')
                    .then( () => {
                        this.$router.push('/');
                    })

            },
            goBack() {
                this.$router.go(-1);
            },
            expandNav: function() {
                let menu = document.getElementById('menu'); 
                let menuOverlay = document.getElementById('menu-overlay'); 
                let menuToggle = document.getElementById('menu-toggle'); 
                menuToggle.classList.toggle('active');
                menu.classList.toggle('active'); 
                menuOverlay.classList.toggle('active');
            },
            navFormSubmit: function(){
                let el = document.getElementById('search'); 
                let value = el.value; 
                
                this.$router.push({
                    path: '/search-results/'+value
                })
            },
            resetSearch(event) {
                let parent = event.target.closest('.app-form');
                let input = parent.querySelector('input[type="text"]');
                input.value='';
                input.focus();
            },
            submitForm: function() {
                let el = document.getElementById('menu-search');
                let value = el.value;
                this.analytics.trackGoal(
                    this.$router.currentRoute.path,
                    'Search',
                    value,
                );

                this.$router.push({ path: '/search-results/' + value });
            }
        }
    }
</script>

<style scoped>
    .visually-hidden { /* https://snook.ca/archives/html_and_css/hiding-content-for-accessibility */
        position: absolute !important;
        height: 1px; width: 1px;
        overflow: hidden;
        clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
        clip: rect(1px, 1px, 1px, 1px);
    }
</style>